import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { Title } from "../../components/NewTitle";

export const CustomerDetailChallenge = (props) => {
  const { t } = useTranslation();
  const { challenges, scale, theme } = props;
  return (
    <section>
      <div className="customer-detail-challenge">
        <div className="inner">
          <div className="content">
            <Title
              title={t("customer.heigh-educate.challenge.title")}
              align="left"
            ></Title>
            <div className="customer-challenge-responsive">
              {challenges.map((challenge, idx) => {
                return (
                  <div className="card" key={`heigh-educate.challenge-${idx}`}>
                    <div className="title-warp">
                      <span
                        className="dot"
                        style={{ background: theme }}
                      ></span>
                      <span className="title">{challenge.title}</span>
                    </div>
                    <div className="text">{challenge.description}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
